module.exports = __webpack_public_path__ + "img/POP-00016-1.8e5a443b.jpg";